import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Subscription } from 'rxjs';
import { NegociarPropostaModel } from 'src/app/aplicacao/models/negociar-proposta.model';
import { OffcanvasService } from 'src/app/shared/services/offcanvas.service';
import { LIMITES_CARACTERES } from 'src/app/aplicacao/helper/limites-caracteres.const';

@Component({
  selector: 'app-formulario-negociar-proposta',
  templateUrl: './formulario-negociar-proposta.component.html',
  styleUrls: ['./formulario-negociar-proposta.component.scss']
})
export class FormularioNegociarPropostaComponent {

  @Input() propostaId;
  @Output() onSubmitSuccess: EventEmitter<any> = new EventEmitter();
  @Output() onClickFechar: EventEmitter<any> = new EventEmitter();
  model = new NegociarPropostaModel();
  validarFormulario = true;
  limiteMaxCaracteres = LIMITES_CARACTERES.OBSERVACAO;
  protected readonly LIMITES_CARACTERES = LIMITES_CARACTERES;
  subscrition = new Subscription();

  constructor( private offcanvasService: OffcanvasService ) {}

  ngOnInit() {
    this.subscrition = this.offcanvasService.aoFecharOffcanvas.subscribe({
      next: () => this.limparFormulario()
    });
  }

  ngOnDestroy() {
    this.subscrition.unsubscribe();
  }

  limparFormulario() {
    this.model = new NegociarPropostaModel()
  }

  enviar(): void {
    this.model.asForm.controls.propostaId.setValue(this.propostaId);
    if(this.model.form.valid) {
      this.validarFormulario = true;
      this.onSubmitSuccess.emit(this.model.form.value);
      this.limparFormulario();
    } else {
      this.validarFormulario = false;
    }
  }

  fechar(){
    this.onClickFechar.emit(true);
    this.limparFormulario();
  }  
}
